// This file contains the development Firebase configuration.
// Update the Firebase config below with your dev Firebase project details.

import { FirebaseOptions } from "@angular/fire/app";

const firebase: FirebaseOptions = {
  apiKey: "AIzaSyDzoT7hS0l9yA0pHvXBXYM_Q8i5UrhUQo0",
  authDomain: "seaside-crew-dev.firebaseapp.com",
  projectId: "seaside-crew-dev",
  storageBucket: "seaside-crew-dev.firebasestorage.app",
  messagingSenderId: "699097963928",
  appId: "1:699097963928:web:01eb7ae1ea9233df6f5fed"
};

export const environment = {
  firebase: firebase,
  production: true,
  emulator: false,
  emulator_functions: false,
  emulatorHost: "",
  recaptcha_key: "6LcKR5EsAAAAAK2BwK-GCPmCRBtMsgB0yWdIEVqR",
  crewApiClient: '',
  crewApiSecret: '',
  apiBaseUrl: 'https://api.dev.sgcrew.no/v1',
};

